import { render, staticRenderFns } from "./LinksPage.vue?vue&type=template&id=54872752&"
import script from "./LinksPage.vue?vue&type=script&lang=js&"
export * from "./LinksPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports